import { gql } from '@apollo/client';
const ADD_PROJECTION_POINT_IMAGE = gql `
  mutation AddProjectionPointImage($projectionPointId: ID!, $file: String!) {
    addProjectionPointPhoto(projectionPointId: $projectionPointId, file: $file) {
      projectionPoint {
        id
        photo
        photoNumber
      }
    }
  }
`;
export default ADD_PROJECTION_POINT_IMAGE;
